import * as token from "@universityofmaryland/web-token-library";
import * as Styles from "@universityofmaryland/web-styles-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/styles";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import { createTextLockupContact } from "../../atomic/text-lockup/contact.js";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../atomic/text-lockup/small.js";
const CreateImageBlock = (props) => {
  const { image, association, pronouns, isThemeDark } = props;
  const wrapper = new ElementBuilder().withClassName(
    "umd-person-hero-image-wrapper"
  );
  const contactContainer = createTextLockupContact({
    ...props,
    isThemeDark: !isThemeDark
  });
  if (image) {
    const imageBlock = createImageBackground({
      element: image,
      isScaled: false,
      imageLoading: "eager",
      imageFetchPriority: "high"
    });
    const imageContainer = new ElementBuilder().withClassName("umd-person-hero-image").withChild(imageBlock).withStyles({
      element: {
        backgroundColor: `${isThemeDark ? token.color.gray.lightest : token.color.gray.darker}`,
        display: "flex",
        justifyContent: "center",
        marginBottom: token.spacing.md,
        ["& img"]: {
          [`@container (max-width: ${token.media.breakpoints.large.max})`]: {
            maxHeight: "160px"
          }
        }
      }
    }).build();
    wrapper.withChild(imageContainer);
  }
  if (association) {
    wrapper.withChild(
      new ElementBuilder(association).styled(
        Styles.typography.sans.compose("large", {
          theme: theme.fontColor(!isThemeDark)
        })
      ).withStyles({
        element: {
          display: "block"
        },
        siblingAfter: {
          marginTop: token.spacing.min
        }
      }).build()
    );
  }
  if (pronouns) {
    wrapper.withChild(
      new ElementBuilder(document.createElement("div")).withClassName("umd-person-hero-pronouns").withStyles({
        element: {
          color: `${isThemeDark ? token.color.black : token.color.white}`,
          fontStyle: "italic",
          ["*"]: {
            color: "currentColor"
          }
        },
        siblingAfter: {
          display: "block",
          marginTop: token.spacing.min
        }
      }).withChild(pronouns).build()
    );
  }
  if (contactContainer) {
    wrapper.withChild(contactContainer);
  }
  const wrapperBuilt = wrapper.build();
  return new ElementBuilder().withClassName("umd-person-hero-image-container").withChild(wrapperBuilt).withStyles({
    element: {
      paddingTop: `${token.spacing.lg}`,
      paddingBottom: `${token.spacing.lg}`,
      backgroundColor: `${isThemeDark ? token.color.gray.lightest : token.color.black}`,
      position: "relative",
      [`@container (max-width: ${token.media.breakpoints.large.max})`]: {
        paddingLeft: `${token.spacing.md}`,
        paddingRight: `${token.spacing.md}`
      },
      [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
        padding: `${token.spacing.md}`,
        width: "30%",
        maxWidth: "320px"
      }
    }
  }).build();
};
const CreateTextContainer = ({
  name,
  slotOne,
  slotFour,
  isThemeDark
}) => {
  const lineWrapper = new ElementBuilder().styled(Styles.element.text.line.adjustentInset).withStyles({
    pseudoBefore: {
      backgroundColor: `${isThemeDark ? token.color.gold : token.color.red}`
    }
  });
  if (slotFour) {
    lineWrapper.withChild(
      new ElementBuilder(slotFour).styled(
        Styles.typography.sans.compose("small", {
          theme: theme.fontColor(isThemeDark)
        })
      ).withStyles({
        element: {
          display: "block",
          textTransform: "uppercase",
          fontWeight: "700",
          maxWidth: "650px"
        },
        siblingAfter: {
          marginTop: token.spacing.min,
          [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
            marginTop: token.spacing.sm
          }
        }
      }).build()
    );
  }
  if (name) {
    lineWrapper.withChild(
      new ElementBuilder(name).styled(
        Styles.typography.campaign.compose("large", {
          theme: theme.fontColor(isThemeDark)
        })
      ).withStyles({
        element: {
          textTransform: "uppercase",
          fontWeight: "700",
          display: "block"
        },
        siblingAfter: {
          marginTop: token.spacing.min,
          [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
            marginTop: token.spacing.md
          }
        }
      }).build()
    );
  }
  if (slotOne) {
    lineWrapper.withChild(
      new ElementBuilder(slotOne).styled(
        Styles.typography.sans.compose("medium", {
          theme: theme.fontColor(isThemeDark)
        })
      ).withStyles({
        element: {
          display: "block",
          ...!isThemeDark && {
            color: token.color.gray.dark
          }
        }
      }).build()
    );
  }
  const lineWrapperBuilt = lineWrapper.build();
  return new ElementBuilder().withClassName("person-hero-text").withChild(lineWrapperBuilt).withStyles({
    element: {
      backgroundColor: `${isThemeDark ? token.color.black : token.color.gray.lightest}`,
      paddingTop: `${token.spacing["3xl"]}`,
      paddingBottom: `${token.spacing["3xl"]}`,
      position: "relative",
      [`@container (max-width: ${token.media.breakpoints.large.max})`]: {
        paddingLeft: `${token.spacing.md}`,
        paddingRight: `${token.spacing.md}`
      },
      [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
        paddingTop: `0`,
        paddingBottom: `${token.spacing["7xl"]}`,
        alignSelf: "flex-start"
      }
    },
    pseudoBefore: {
      content: '""',
      position: "absolute",
      top: "-100px",
      left: "0",
      bottom: "0",
      width: "200vw",
      transform: "translateX(-20%)",
      backgroundColor: `${isThemeDark ? token.color.black : token.color.gray.lightest}`
    }
  }).build();
};
const CreatePersonHeroElement = (props) => {
  const { breadcrumbMobile, breadcrumbDesktop } = props;
  const textContainer = CreateTextContainer(props);
  const textColumns = new ElementBuilder().withClassName("umd-person-hero-columns").withChild(textContainer).withStyles({
    element: {
      [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
        width: "70%"
      }
    }
  });
  if (breadcrumbDesktop) {
    const textColumnBreadcrumb = new ElementBuilder().withClassName("umd-person-hero-breadcrumb-desktop").withChild(breadcrumbDesktop).withStyles({
      element: {
        [`@container (max-width: ${token.media.breakpoints.large.max})`]: {
          display: "none"
        }
      }
    }).build();
    textColumns.withChild(textColumnBreadcrumb);
  }
  const textColumnsBuilt = textColumns.build();
  const imageBlock = CreateImageBlock(props);
  const elementWrapper = new ElementBuilder().withClassName("umd-person-hero-wrapper").withChild(textColumnsBuilt).withChild(imageBlock).withStyles({
    element: {
      [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: `${token.spacing["7xl"]}`
      }
    }
  }).build();
  const elementLock = new ElementBuilder().styled(Styles.layout.space.horizontal.larger).withChild(elementWrapper).withStyles({
    element: {
      [`@container (max-width: ${token.media.breakpoints.large.max})`]: {
        padding: "0"
      }
    }
  });
  if (breadcrumbMobile) {
    const mainBreadcrumb = new ElementBuilder().withClassName("umd-person-hero-breadcrumb-mobile").withChild(breadcrumbMobile).withStyles({
      element: {
        paddingLeft: `${token.spacing.md}`,
        paddingRight: `${token.spacing.md}`,
        [`@container (min-width: ${token.media.breakpoints.tablet.min})`]: {
          display: "none"
        }
      }
    }).build();
    elementLock.withChild(mainBreadcrumb);
  }
  const elementLockBuilt = elementLock.build();
  return new ElementBuilder().withClassName("umd-person-hero").withChild(elementLockBuilt).withStyles({
    element: {
      overflow: "hidden",
      containerType: "inline-size"
    }
  }).build();
};
const createCompositePersonHero = CreatePersonHeroElement;
export {
  createCompositePersonHero
};
//# sourceMappingURL=hero.js.map
